import { navigate } from 'gatsby'
import React from 'react'
import { Card, Segment } from 'semantic-ui-react'
import ImageHolder from '../ImageHolder'


import * as styles from './styles/carousel.module.css'
import AddToCartListing from '../AddToCart/addToCartListing'

const ProductCard = ({
    item,
    index,

    carouselRef,
    mouseMovement,
    isItemsLoading,
    listName,

    header,
    cardProps,
    cardClassname,

    displayImage,
    imageHeightToWidthRatio,
    displayName,
    userExclusiveList,
    displaySummary
}) => {

    let {
        name,
        id,
        meta,
        sku,
        url,
        mainImageHref,
        available,
        price,
        exclusive,
        uom // unit of measurement
    } = item;

    // Some product id is in the root level, some are inside meta
    let productId = "";
    if (id !== undefined && id !== null) {
        productId = id;
    } else if (meta !== undefined && meta.hasOwnProperty('id')) {
        productId = meta.id;
    }

    // Some product uom is in the root level, some are inside meta
    let productUOM = undefined;
    if (uom !== undefined && uom !== null) {
        productUOM = uom;
    } else if (meta !== undefined && meta.hasOwnProperty('uom')) {
        productUOM = meta.uom;
    }

    let pricestr = "0.00"
    var priceval = 0;

    if (meta) {
        if (price !== undefined) {
            priceval = parseFloat(price)
            // Add commas and two decimal places
            pricestr = priceval.toLocaleString('en-us', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            })
        } else {
            pricestr = meta.display_price.with_tax.formatted
            priceval = parseFloat(meta.display_price.with_tax.amount)
        }
    }

    let exclusivestr = "0.00";
    let exclusiveval = 0;

    if (exclusive === undefined) {
        exclusive = []
    }

    if (meta !== undefined) {
        if (meta.hasOwnProperty("exclusive")) {
            exclusive = meta.exclusive;
        }
    }

    // Checks if user has registered to any franchise, seminar, course.
    if (userExclusiveList.length > 0 && exclusive !== undefined) {
        // Checks if product has special rates
        if (exclusive.length > 0) {
            // Filter the special rates applicable to the user
            const applicablePrices = exclusive.filter((e) => {
                return userExclusiveList.includes(e.code);
            })

            // Checks if there are any applicable special rates
            if (applicablePrices.length > 0) {
                let lowestApplicablePrice = applicablePrices[0].price;

                // Find the lowest price among the applicable special rates
                for (const applicablePrice of applicablePrices) {
                    if (applicablePrice < lowestApplicablePrice) {
                        lowestApplicablePrice = applicablePrice.price;
                    }
                }

                // Set the exclusive price to be the lowest applicable special rate
                exclusiveval = lowestApplicablePrice;
            }

            // Format exclusive/special rate (add commas and decimal places)
            if (exclusiveval > 0) {
                exclusivestr = exclusiveval.toLocaleString('en-us', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                })
            }
        }
    }

    return (
        <Card
            {...cardProps}
            draggable="false" // to prevent dragging link when higlighting text in add to cart input
            className={cardClassname}
            onMouseDown={(e) => {
                // Fires on Desktop only
                mouseMovement.current = {
                    startX: e.clientX, startY: e.clientY,
                    endX: e.clientX, endY: e.clientY
                }
            }}
            onMouseUp={(e) => {
                // Fires on Desktop only; when released within carousel component
                mouseMovement.current.endX = e.clientX;
                mouseMovement.current.endY = e.clientY;
            }}
            onClick={(e) => {
                // Fires Mobile and Desktop (after mouse up, when w/in carousel compponent)
                e.preventDefault();
                const distanceX = Math.abs(mouseMovement.current.startX - mouseMovement.current.endX)
                const distanceY = Math.abs(mouseMovement.current.startY - mouseMovement.current.endY)

                // 5% of the Carousel width
                const threshold = carouselRef.current.offsetWidth * 0.05;

                if (distanceX < threshold && distanceY < threshold) {
                    window.dataLayer = window.dataLayer || [];
                    window.dataLayer.push({
                        'event': 'productClick',
                        'ecommerce': {
                            'click': {
                                'actionField': { 'list': listName },
                                'products': [{
                                    'name': name,
                                    'id': sku ?? meta.sku,
                                    'price': priceval,
                                    'position': index + 1,
                                    'item_id': sku ?? meta.sku,
                                    'item_name': name,
                                    'currency': "PHP",
                                    'index': index + 1,
                                    'item_list_id': listName,
                                    'item_list_name': listName,
                                    'quantity': 1
                                }]
                            }
                        }
                    });

                    if (!isItemsLoading) {
                        let cardState = { cameFrom: `carousel-${header}`, index: index + 1 }

                        navigate(`/${url}/`, { state: cardState });
                    }
                }
            }}
        >   
            {/* PRODUCT IMAGE */}
            <ImageHolder
                heightToWidthRatio={imageHeightToWidthRatio}
                src={displayImage ?? mainImageHref}
                alt={name}
                displayMode={isItemsLoading ? "loading" : "default"}
            />

            <Card.Content className={styles.productContent}>
                {/* PRODUCT NAME */}
                <Card.Header className={styles.productHeader}>
                    {displayName}
                </Card.Header>

                {/* PRODCT DESCRIPTION (e.g. name, pricing) */}
                <Card.Description className={`${styles.productDescription}`}>
                    <Segment
                        basic
                        className={`${styles.priceContainer} ${exclusiveval > 0 ? styles.specialPrice : ''}`}
                    >
                        {exclusiveval > 0 && <span>Special Member Price</span>}

                        {/* PRICE */}
                        {priceval > 0 || exclusiveval > 0
                            ? <>
                                <p className={`${styles.productPrice}`}>
                                    <span>&#8369;
                                        {exclusiveval > 0 ? exclusivestr : pricestr}
                                    </span>
                                    {/* UOM */}
                                    {/* Remove the false when uom is ready to be displayed */}
                                    {productUOM !== undefined && false && <>
                                        {productUOM.length > 0 ? <><br />/{productUOM}</> : ""}
                                    </>}
                                </p>
                            </>
                            : available === false && <>
                                <p><span>Exclusive Item</span></p>
                            </>
                        }
                    </Segment>
                    <div className={`${styles.meta} ${styles.warningMessage}`}>
                        {exclusiveval > 0
                            ? priceval > 0
                                ? <p className={`${styles.regularPrice}`}>
                                    Regularly <span>&#8369;{pricestr}</span>
                                </p>
                                : <>Special Offer</>
                            : available === false && (priceval > 0
                                ? <>Product no longer available.</>
                                : <>&nbsp;</>)
                        }
                        {!(priceval > 0 || exclusiveval > 0) && available === false &&
                            <>For selected members only</>
                        }
                        {(displaySummary.trim().length > 0) &&
                            <>{displaySummary}</>
                        }
                    </div>
                </Card.Description>
            </Card.Content>

            {/* ADD TO CART BUTTON */}
            {!isItemsLoading && <>
                <AddToCartListing
                    disabled={exclusiveval === 0 && available === false}
                    product={{
                        id: productId,
                        name,
                        price: pricestr,
                        sku: meta.sku,
                        image: displayImage ?? mainImageHref
                    }}
                />
            </>}
        </Card>
    )
}

export default ProductCard